import { render } from "./ReturnList.vue?vue&type=template&id=2989a93f&scoped=true"
import script from "../js/return-list.js?vue&type=script&lang=js&external"
export * from "../js/return-list.js?vue&type=script&lang=js&external"

import "./ReturnList.vue?vue&type=style&index=0&id=2989a93f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2989a93f"]])

export default __exports__